/**
 * Optimizer Control Center — live next-run countdown cell. A row that would
 * run (auto / due) while its tracker's own switch holds the scheduler (Tres
 * Commas: off by default) reads "Held" — the reason in the tooltip — instead
 * of counting down to a run that will not push.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import type { OptimizerRow } from '@/features/optimizer-center/optimizer-center.types';
import {
  formatCountdown,
  nextRunInfo,
} from '@/features/optimizer-center/utils/next-run-info';
import { useTrackerBlockedReason } from '@/features/trackers/flow-optimizer';

import { HeldCell } from './held';

export const NextRunCell: FC<{ row: OptimizerRow; nowMs: number }> = ({
  row,
  nowMs,
}) => {
  const info = nextRunInfo(row, nowMs);
  const held = useTrackerBlockedReason(row.provider);

  if (info.state === 'standard' || info.state === 'manual') {
    return <span className="text-muted-foreground">—</span>;
  }
  if (info.state === 'paused') {
    return <span className="text-warning">Paused</span>;
  }
  if (held) return <HeldCell reason={held} />;
  if (info.state === 'due') {
    return <span className="font-medium text-success">due now</span>;
  }
  return (
    <span className="font-mono text-xs tabular-nums" data-testid="next-run-countdown">
      {formatCountdown(info.msLeft ?? 0)}
    </span>
  );
};
